var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from "react";
export var useProductNumberAssignOptions = function (internationalPrefixes, allInternationalPrefixes, selectedInternationalPrefixId, agencyPrefixes, selectedAgencyPrefixId, publisherPrefixes, selectedPublisherPrefixId) {
    var internationalPrefixOptions = useMemo(function () {
        var options = [];
        var merged = __spreadArray(__spreadArray([], allInternationalPrefixes, true), internationalPrefixes, true);
        if (selectedInternationalPrefixId && merged.length > 0) {
            var selectedPrefix = merged.find(function (prefix) { return prefix.id === selectedInternationalPrefixId; });
            if (selectedPrefix && selectedPrefix.id) {
                options.push({
                    value: selectedPrefix.id,
                    label: "".concat(selectedPrefix.agency || "", " - ").concat(selectedPrefix.value || ""),
                });
            }
        }
        merged.forEach(function (prefix) {
            if (prefix.id && !options.find(function (option) { return option.value === prefix.id; })) {
                options.push({
                    value: prefix.id,
                    label: "".concat(prefix.agency || "", " - ").concat(prefix.value || ""),
                });
            }
        });
        return options;
    }, [
        internationalPrefixes,
        allInternationalPrefixes,
        selectedInternationalPrefixId,
    ]);
    var agencyPrefixOptions = useMemo(function () {
        var _a;
        var options = [];
        if (selectedAgencyPrefixId && agencyPrefixes.length > 0) {
            var selectedAgencyPrefix = agencyPrefixes.find(function (prefix) { return prefix.id === selectedAgencyPrefixId; });
            if (selectedAgencyPrefix && selectedAgencyPrefix.id) {
                options.push({
                    value: selectedAgencyPrefix.id,
                    label: "".concat(((_a = selectedAgencyPrefix.internationalPrefix) === null || _a === void 0 ? void 0 : _a.value) || "", "-").concat(selectedAgencyPrefix.value || ""),
                });
            }
        }
        if (Array.isArray(agencyPrefixes)) {
            agencyPrefixes.forEach(function (prefix) {
                var _a;
                if (prefix.id &&
                    !options.find(function (option) { return option.value === prefix.id; })) {
                    options.push({
                        value: prefix.id,
                        label: "".concat(((_a = prefix.internationalPrefix) === null || _a === void 0 ? void 0 : _a.value) || "", "-").concat(prefix.value || ""),
                    });
                }
            });
        }
        return options;
    }, [agencyPrefixes, selectedAgencyPrefixId]);
    var publisherPrefixOptions = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var options = [];
        if (selectedPublisherPrefixId && publisherPrefixes.length > 0) {
            var selectedPrefix = publisherPrefixes.find(function (prefix) { return prefix.id === selectedPublisherPrefixId; });
            if (selectedPrefix && selectedPrefix.id) {
                var remainingNumbers = Number((_b = (_a = selectedPrefix.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : 0) -
                    Number((_c = selectedPrefix.nextSequence) !== null && _c !== void 0 ? _c : 0);
                options.push({
                    value: selectedPrefix.id,
                    label: "".concat(((_f = (_e = (_d = selectedPrefix.publisherPrefixRange) === null || _d === void 0 ? void 0 : _d.agencyPrefix) === null || _e === void 0 ? void 0 : _e.internationalPrefix) === null || _f === void 0 ? void 0 : _f.value) || "", "-").concat(((_h = (_g = selectedPrefix.publisherPrefixRange) === null || _g === void 0 ? void 0 : _g.agencyPrefix) === null || _h === void 0 ? void 0 : _h.value) || "", "-").concat(selectedPrefix.value, " (zb\u00FDv\u00E1 ").concat(remainingNumbers, ")"),
                });
            }
        }
        if (Array.isArray(publisherPrefixes)) {
            publisherPrefixes.forEach(function (prefix) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                if (prefix.id &&
                    !options.find(function (option) { return option.value === prefix.id; })) {
                    var remainingNumbers = Number((_b = (_a = prefix.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : 0) -
                        Number((_c = prefix.nextSequence) !== null && _c !== void 0 ? _c : 0);
                    options.push({
                        value: prefix.id,
                        label: "".concat(((_f = (_e = (_d = prefix.publisherPrefixRange) === null || _d === void 0 ? void 0 : _d.agencyPrefix) === null || _e === void 0 ? void 0 : _e.internationalPrefix) === null || _f === void 0 ? void 0 : _f.value) || "", "-").concat(((_h = (_g = prefix.publisherPrefixRange) === null || _g === void 0 ? void 0 : _g.agencyPrefix) === null || _h === void 0 ? void 0 : _h.value) || "", "-").concat(prefix.value, " (zb\u00FDv\u00E1 ").concat(remainingNumbers, ")"),
                    });
                }
            });
        }
        return options;
    }, [publisherPrefixes, selectedPublisherPrefixId]);
    return {
        internationalPrefixOptions: internationalPrefixOptions,
        agencyPrefixOptions: agencyPrefixOptions,
        publisherPrefixOptions: publisherPrefixOptions,
    };
};
